const AVATAR_PRESET_SIZES = [
  "xsmall",
  "small",
  "default",
  "large",
  "xlarge"
];
const AVATAR_SIZE_RECORD = {
  xsmall: 24,
  small: 32,
  default: 40,
  large: 48,
  xlarge: 56
};

export { AVATAR_PRESET_SIZES, AVATAR_SIZE_RECORD };
//# sourceMappingURL=size.mjs.map
